import React, { Component } from "react";
import {
  View,
  StyleSheet,
  ScrollView,
  TouchableHighlight,
  KeyboardAvoidingView,
  Dimensions,
  Image,
  Linking,
  Platform,
} from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import Theme from "../argon-ui/Theme";
import { IconButton } from "../components_v2/Buttons";

import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import {
  faPlus,
  faCalendar,
  FONT_FAMILIES,
} from "../../assets/consts/faCharCodes";
import PersianCalendarPicker from "react-native-persian-calendar-picker";
import InputSpinner from "react-native-input-spinner";

import * as Actions from "../actions/ApiActions";
import { translate } from "../locales/translate";
import Loading from "../components/Loading";
import OrderListItem from "./components/OrderListItem";
import { getIconPicture } from "./components/Icons";
import FilterItem from "../components_v2/FilterItem";
import { englishToPersianNumber } from "../util";
import InputBase from "../nativeBase-ui/InputBase";
import Select from "../nativeBase-ui/Select";
import InputSearch from "../components_v2/InputSearch";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import ToastAlert from "../nativeBase-ui/ToastAlert";
import { Toast } from "native-base";
import ModalBase from "../nativeBase-ui/ModalBase";

const SCREEN_WIDTH = Dimensions.get("window").width;
let moment = require("moment-jalaali");
class RestaurantAndCoffeeShopScreen extends Component {
  constructor(props) {
    super(props);
    this.orderTypes = ["ALL"];
    this.orderStatuses = ["ALL"];
    this._sortModes = {
      sortByTime: "orderSortByTime",
      sortByType: "orderSortByType",
      getArray: () => {
        var arr = [];
        for (var i in this._sortModes) {
          if (
            this._sortModes[i] &&
            {}.toString.call(this._sortModes[i]) === "[object Function]"
          ) {
            continue;
          }
          arr.push({
            label: translate(`api.${this._sortModes[i]}`),
            value: this._sortModes[i],
          });
        }
        if (Platform.OS == "web") {
          arr.unshift({
            label: translate("app.orderSortBy"),
            value: "orderSortBy",
          });
        }
        return arr;
      },
    };

    this.state = {
      accessToken: "",
      serverUrl: "",
      isLoading: true,
      orderTypeFilter: "ALL",
      orderStatusFilter: "ALL",
      orderDescriptionFilter: "",
      orderSortFilter: null,
      loadingError: false,
      isLoadingPaymentDetails: false,
      paymentDetails: null,
      showModal: 0,
      isNewOrder: true,
      orderSelected: null,
      //new Order
      newOrderType: "Restaurant",
      pDateDesired: null,
      twoModals: false,
      newOrderUnitId: null,
      restaurantTypeList: [{ text: translate("api.orderTypes.ALL"), value: 0 }],
      coffeeShopTypeList: [{ text: translate("api.orderTypes.ALL"), value: 0 }],
      foods: [],
      getFoodFilter: [],
      coffees: [],
      getCoffeeFilter: [],
      requestItems: [],
      newOrderServiceType: null,
      orderedItems: [],
      orderPrice: 0,
      newOrder: false,
      selectedTypeCategory: 0,
      minItemNum: 1,
      allNumItems: 0,
      selectedPaymentItem: null,
      orderDesc: null,
      pTimeDesiredBegin: null,
      pTimeDesiredEnd: null,
      userBalance: 0,
      unitBalance: 0,
      isShowingCancelAlert: false,
      paymentOnlineUrl: null,
      isOrderRegistering: true,
      isUserValid: "",
      imageServerUrl: "http://ribbon.taplife.ir:88",
      imageUrl: "",
      copyList: [],
      changeOrderItem: [],
      areaList: [],
      isAccessToUnitCredit: false,
      reservationUser: null,
      getInfoHasError: false,
      isRestaurantActive: false,
      isCoffeeShopActive: false,
    };
    this.onDateChange = this.onDateChange.bind(this);
    // this.modalToastRef = undefined;
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.RestaurantAndCoffeeShop"),
  });
  componentDidMount() {
    let { currentServer, serverUrl } = this.props.appReducer;
    const accessToken = currentServer.accessToken;
    var _serverUrl = serverUrl;
    if (!_serverUrl.endsWith("/")) {
      _serverUrl = _serverUrl + "/";
    }
    this.setState({ accessToken, serverUrl: _serverUrl }, () => {
      this.getRestaurantAndCoffeeShopInfo();
      this.getUser().then(() => {
        this.props.MyOrders(accessToken);
        this.getUserAreas();
        this.setState({ isLoading: false });
      });
      this.getAllInfo();
    });
  }

  getAllInfo() {
    this.getCoffeeItems(),
      this.getCoffeeType(),
      this.getFoodItems(),
      this.getRestaurantType();
  }
  getRestaurantAndCoffeeShopInfo() {
    let { accessToken, serverUrl } = this.state;
    var restaurantUrl = `${serverUrl}Services/GetRestaurantInfo`;
    var coffeeShopUrl = `${serverUrl}Services/GetCoffeeShopInfo`;
    fetch(restaurantUrl, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess" || resj.ErrorCode != null) {
          this.setState({ getInfoHasError: "Yes" }, () => {});
        } else {
          this.setState({
            isRestaurantActive: resj.boolActive,
            newOrderType: resj?.boolActive ? "Restaurant" : "CoffeeShop",
          });
        }
      })
      .catch((err) => {
        {
          console.log(err, "get restaurant info");
        }
      });
    fetch(coffeeShopUrl, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess" || resj.ErrorCode != null) {
          this.setState({ getInfoHasError: "Yes" }, () => {});
        } else {
          this.setState({ isCoffeeShopActive: resj.boolActive });
        }
      })
      .catch((err) => {
        {
          console.log(err, "get coffeeShop info");
        }
      });
  }
  onAddButtonPress = () => {
    this.setState(
      {
        newOrder: true,
        orderPrice: 0,
        order,
        copyList: [],
        changeOrderItem: [],
        isOrderRegistering: true,
        selectedPaymentItem: null,
      },
      this.getAllInfo()
    );
  };

  hideModal = () => {
    this.setState({
      showModal: 0,
      isNewOrder: true,
      orderSelected: null,
      pDateDesired: null,
      getFoodFilter: [],
      getCoffeeFilter: [],
      newOrderServiceType: null,
      selectedPaymentItem: null,
      orderDesc: null,
      userBalance: 0,
      unitBalance: 0,
      paymentOnlineUrl: null,
      isOrderRegistering: true,
      copyList: [],
      changeOrderItem: [],
    });
  };
  getUser() {
    return new Promise((resolve, reject) => {
      let { serverUrl, accessToken } = this.state;
      var url = `${serverUrl}Services/GetRibbonUser/`;
      fetch(url, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          if (resj.errors == "NoAccess" || resj.ErrorCode != null) {
            this.setState({ isUserValid: "No" }, () => {
              resolve();
            });
          } else {
            this.setState({ reservationUser: resj, isUserValid: "Yes" });
            resolve();
          }
        })
        .catch((err) => {
          {
            console.log(err, "get user have error ");
            reject(err);
          }
        });
    });
  }

  hideCancelConfirm() {
    this.setState({
      isShowingCancelAlert: false,
    });
  }
  hideTwoModals = () => {
    this.setState({ twoModals: false });
  };
  toDigit(num) {
    if (Number(num) != NaN) {
      return (100 + Number(num)).toString().substr(1);
    }
    return num;
  }
  onDateChange(date) {
    this.setState({ pDateDesired: date });
    this.hideTwoModals();
    return;
  }
  getBalanceAmount() {
    return new Promise((resolve, reject) => {
      if (!this.state.isAccessToUnitCredit) {
        return null;
      }
      let { serverUrl, accessToken } = this.state;
      let args = [];
      args.push(`UnitCode=${this.state.newOrderUnitId}`);
      var url = `${serverUrl}Services/GetBalance/?${args.join("&")}`;
      fetch(url, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          if (resj.errors == "NoAccess" || resj.errorCode != null) {
            this.setState({ isUserValid: "No" });
          } else {
            if (this.state.isAccessToUnitCredit) {
              this.setState(
                {
                  userBalance: Number(resj.userBalance),
                  unitBalance: Number(resj.unitBalance),
                  isUserValid: "Yes",
                },
                () => {
                  resolve();
                }
              );
            } else {
              this.setState(
                {
                  userBalance: Number(resj.userBalance),
                  unitBalance: -1,
                  isUserValid: "Yes",
                },
                () => {
                  resolve();
                }
              );
            }
          }
        })
        .catch((err) => {
          {
            console.log(err, "balanceAmount");
            // this.showModalToast(translate("api.getBalanceError"));
            reject(err);
          }
        });
    });
  }
  getUserAreas() {
    let { serverUrl, accessToken } = this.state;
    var url = `${serverUrl}Services/GetRibbonUserInUnit/`;
    fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess" || resj.ErrorCode != null) {
          this.setState({ isUserValid: "No" });
        } else {
          var areas = [];
          for (var i in resj) {
            areas.push({
              label: resj[i].strUnitName,
              boolUseUnitCredit: resj[i].boolUseUnitCredit,
              boolIncreaseUnitCredit: resj[i].boolIncreaseUnitCredit,
              value: resj[i].numUnitRef,
            });
          }
          if (Platform.OS == "web") {
            areas.unshift({
              label: translate("api.orderUnit"),
              value: "orderUnit",
            });
          }
          this.setState({
            areaList: areas,
          });
        }
      })
      .catch((err) => {
        {
          console.log(err, "get userInUnit have error ");
          reject(err);
        }
      });
  }
  getCoffeeType() {
    let { serverUrl, accessToken } = this.state;
    var url = `${serverUrl}Services/GetCoffeeShopServiceType/}`;
    fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess") {
          this.showToast(translate("api.serviceNoAccess"));
        } else if (resj.errors != null) {
          this.showToast(translate("api.getServiceDetailsError"));
        } else {
          if (resj == null) {
            this.setState({ isNewOrder: false });
            return;
          }
          for (var i in resj) {
            this.state.coffeeShopTypeList.push({
              text: resj[i].strCoffeeTypeName,
              value: resj[i].numCoffeeTypeCode,
            });
          }
          this.setState({ isNewOrder: false });
        }
      })
      .catch((err) => {
        {
          console.log(err);
          // this.showModalToast(translate("api.getServiceDetailsError"));
        }
      });
  }
  getCoffeeItems() {
    let { serverUrl, accessToken } = this.state;
    var url = `${serverUrl}Services/GetCoffeeShopServiceCoffee/`;
    fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess") {
          this.showToast(translate("api.serviceNoAccess"));
        } else if (resj.errors != null) {
          this.showToast(translate("api.getServiceDetailsError"));
        } else if (resj.errorCode) {
          this.setState({ coffees: [] });
        } else {
          this.setState({ coffees: resj, isNewOrder: false });
        }
      })
      .catch((err) => {
        {
          console.log(err, "getCoffee");
          // this.showToast(translate("api.getServiceDetailsError"));
        }
      });
  }
  getRestaurantType() {
    let { serverUrl, accessToken } = this.state;
    var url = `${serverUrl}Services/GetRestaurantServiceType/}`;
    fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess") {
          this.showToast(translate("api.serviceNoAccess"));
        } else if (resj.errors != null) {
          this.showToast(translate("api.getServiceDetailsError"));
        } else {
          if (resj == null) {
            this.setState({ isNewOrder: false });
            return;
          }
          var newList = [...this.state.restaurantTypeList];
          for (var i in resj) {
            newList.push({
              text: resj[i].strFoodTypeName,
              value: resj[i].numFoodTypeCode,
            });
          }
        }

        this.setState({ restaurantTypeList: newList });
      })
      .catch((err) => {
        {
          console.log(err);
          // this.showModalToast(translate("api.getServiceDetailsError"));
        }
      });
  }
  getFoodItems() {
    let { serverUrl, accessToken } = this.state;
    var url = `${serverUrl}Services/GetRestaurantServiceFood/}`;
    fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess") {
          this.showToast(translate("api.serviceNoAccess"));
        } else if (resj.errors != null) {
          this.showToast(translate("api.getServiceDetailsError"));
        } else if (resj.errorCode) {
          this.setState({ foods: [] });
        } else {
          this.setState({ foods: resj, isNewOrder: false });
        }
      })
      .catch((err) => {
        {
          console.log(err);
          // this.showModalToast(translate("api.getServiceDetailsError"));
        }
      });
  }
  clearCart() {
    this.setState({ orderedItems: [], orderPrice: 0 });
  }

  countOrderedItem(value, obj) {
    var indexObj = this.state.orderedItems.indexOf(obj);
    var newList = [...this.state.orderedItems];
    if (indexObj != -1) {
      var itemNum = newList[indexObj].itemNum;
      if (value == 0) {
        newList.splice(indexObj, 1);
        this.setState({
          orderedItems: newList,
          allNumItems: this.state.allNumItems - itemNum,
          orderPrice: this.state.orderPrice - obj.numPrice,
        });
      } else {
        newList[indexObj].itemNum = value;
        this.setState({
          orderedItems: newList,
          allNumItems: this.state.allNumItems - itemNum + value,
          orderPrice: this.state.orderPrice + (value - itemNum) * obj.numPrice,
        });
      }
    } else {
      if (
        obj.numRemainingFoodCount > this.state.minItemNum ||
        obj.numRemainingCoffeeCount > this.state.minItemNum
      ) {
        obj.itemNum = value;
        newList.push(obj);
        this.setState({
          orderedItems: newList,
          allNumItems: this.state.allNumItems + value,
          orderPrice: this.state.orderPrice + obj.numPrice,
        });
        return;
      }
      this.showToast(translate("api.inexistent", "info"));
    }
  }
  refreshOrderList() {
    this.props.MyOrders(this.state.accessToken);
    this.setState({ newOrder: false });
  }

  cancelOrder() {
    const cancelState = 6;
    if (this.state.orderSelected.data.numOrderStatus == cancelState) {
      this.showToast(translate("api.canceled"), "info");
      return;
    }
    let { serverUrl, accessToken } = this.state;
    var args = [];
    args.push(`RequestID=${this.state.orderSelected.data.numOrderID}`);
    var url = `${serverUrl}Services/Put${
      this.state.newOrderType
    }OrderCancel/?${args.join("&")}`;
    fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess") {
          this.showToast(translate("api.cancelNoAccess"));
        } else if (resj.ErrorCode != null) {
          this.showToast(translate("api.cancelNoAccess"));
        } else {
          this.showToast(translate("api.cancelSuccess"), "success");
          this.hideModal();
          this.refreshOrderList();
        }
      })
      .catch((err) => {
        {
          console.log(err);
          // this.showModalToast(translate("api.cancelError"));
        }
      });
  }
  getPaymentOnlineUrl() {
    let { serverUrl, accessToken } = this.state;
    var args = [];
    args.push(`RequestID=${this.state.orderSelected?.data.numOrderID}`);
    args.push(
      `paymentType=${this.state.orderSelected?.data.payment.numPaymentType}`
    );
    args.push(`Amount=${this.state.orderSelected?.data.numOrderPrice}`);
    args.push(
      `orderType=${this.state.orderSelected?.data.numPublicServiceType}`
    );

    var url = `${serverUrl}Services/GetOnlinePaymentUrl/?${args.join("&")}`;
    fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errorCode != null) {
          this.showToast(translate("api.orderAnswerError"));
        } else {
          this.setState({ paymentOnlineUrl: resj.paymentUrl }, () => {
            if (Platform.OS === "web") {
              window.open(this.state.paymentOnlineUrl);
            } else {
              Linking.openURL(this.state.paymentOnlineUrl);
            }
          });
        }
      })
      .catch((err) => {
        {
          console.log(err);
        }
      });
  }

  formatNumber(n) {
    "use strict";
    if (Number.isInteger(n)) {
      return n.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    } else {
      return null;
    }
  }

  registerNewOrder() {
    if (
      this.state.newOrderUnitId != null &&
      Number.isInteger(this.state.selectedPaymentItem) &&
      this.state.orderedItems.length != 0
    ) {
      let { serverUrl, accessToken } = this.state;
      let args = [];
      var orderItems = "";
      for (var i in this.state.orderedItems) {
        orderItems =
          orderItems +
          `${
            this.state.orderedItems[i].numFoodCode ||
            this.state.orderedItems[i].numCoffeeCode
          }:${this.state.orderedItems[i].itemNum},`;
      }
      args.push(`UnitCode=${this.state.newOrderUnitId}`);
      args.push(`OrderItems=${orderItems}`);
      args.push(`PaymentType=${this.state.selectedPaymentItem}`);
      if (this.state.orderDesc == null) {
        args.push(`OrderDesc=${"-"}`);
      } else {
        args.push(`OrderDesc=${this.state.orderDesc}`);
      }
      if (this.state.pDateDesired == null) {
        var finalDate = "";
        var pDates = new Date();
        var pDate = moment(pDates).format("jYYYY/jM/jD");
        var parsDate = pDate.split("/");
        finalDate = pDate;
        if (parsDate[1].length == 1) {
          var mm = "0" + parsDate[1];
          finalDate = parsDate[0] + "/" + mm + "/" + parsDate[2];
        }
        args.push(`PdateDesired=${finalDate}`);
      }
      // pDateDesired isn't null
      else {
        var finalDate = "";
        var pDate = "";

        pDate = moment(this.state.pDateDesired)
          .format("jYYYY/jM/jD")
          .toString();
        var parsDate = pDate.split("/");
        finalDate = pDate;
        if (parsDate[1].length == 1) {
          var mm = "0" + parsDate[1];
          finalDate = parsDate[0] + "/" + mm + "/" + parsDate[2];
        }

        args.push(`PdateDesired=${finalDate}`);
      }
      if (this.state.pTimeDesiredBegin == null) {
        args.push(`PTimeDesiredBegin=${" "}`);
      } else {
        args.push(`PTimeDesiredBegin=${this.state.pTimeDesiredBegin}`);
      }
      if (this.state.pTimeDesiredEnd == null) {
        args.push(`PTimeDesiredEnd=${" "}`);
      } else {
        args.push(`PTimeDesiredEnd=${this.state.pTimeDesiredEnd}`);
      }
      args.push(`Amount=${this.state.orderPrice}`);
      var url = `${serverUrl}Services/Post${
        this.state.newOrderType
      }RegisterOrder/?${args.join("&")}`;
      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          if (resj.errors == "NoAccess") {
            this.showToast(translate("api.serviceNoAccess"));
          }
          if (resj.errorCode != null) {
            this.showToast(resj.errorMessage);
            this.setState({ isOrderRegistering: true });
          } else {
            if (this.state.selectedPaymentItem != 4) {
              this.showToast(translate("api.registeredNewOrder"), "success");
              this.hideModal();
              this.props.MyOrders(this.state.accessToken);
              this.setState({
                isOrderRegistering: true,
                orderedItems: null,
                selectedPaymentItem: null,
                newOrder: false,
                allNumItems: 0,
                selectedTypeCategory: 0,
              });
            } else if (this.state.selectedPaymentItem == 4)
              this.setState({ paymentOnlineUrl: resj.paymentUrl }, () => {
                if (Platform.OS === "web") {
                  window.open(this.state.paymentOnlineUrl);
                } else {
                  Linking.openURL(this.state.paymentOnlineUrl);
                }
              });
            if (this.props.reducer.confirm) {
              this.showToast(translate("api.registeredNewOrder"));
            } else {
              this.showToast(translate("api.noPaymentOnlineSuccessFul"));
            }
            this.hideModal();
            this.refreshOrderList();
            this.setState({
              isOrderRegistering: true,
              orderedItems: null,
              selectedPaymentItem: null,
              newOrder: false,
              allNumItems: 0,
              selectedTypeCategory: 0,
            });
          }
        })
        .catch((err) => {
          {
            console.log(err);
          }
        });
    } else {
      if (this.state.newOrderUnitId == null) {
        this.showToast(translate("api.enterUnit"));
      } else if (this.state.orderedItems.length == 0) {
        this.showToast(translate("api.noItemSelected"));
      } else if (this.state.orderedItems.length == 0) {
        this.showToast(translate("api.enterItem"));
      } else if (!Number.isInteger(this.state.selectedPaymentItem)) {
        this.showToast(translate("api.enterPaymentItem"));
      }
      this.setState({ isOrderRegistering: true });
    }
  }
  goBack = () => {
    this.props.navigation.goBack();
  };
  // === show toast => toast native-base ===
  showToast = (message, status = "error") => {
    const toastDetail = {
      title: message,
      variant: "subtle",
      status,
    };
    Toast.show({
      duration: 2000,
      render: () => {
        return <ToastAlert {...toastDetail} />;
      },
    });
  };
  render() {
    if (this.state.isUserValid == "No") {
      return (
        <View
          style={{ alignItems: "center", flex: 1, justifyContent: "center" }}
        >
          <Text style={{ fontSize: 20, color: "#666666" }}>
            {translate("api.invalidUserReserveApi")}
          </Text>
        </View>
      );
    } else if (this.state.isLoading || this.props.reducer.isLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    } else if (this.state.loadingError) {
      return (
        <View
          style={{ flex: 1, alignItems: "center", justifyContent: "center" }}
        >
          <Text
            style={{
              color: Theme.COLORS.ERROR,
              textAlign: "center",
            }}
          >
            {translate("app.loadingError")}
          </Text>
        </View>
      );
    }
    var foodList = [];
    if (this.state.foods.length != 0) {
      foodList = this.state.foods?.sort((a, b) =>
        a.numRemainingFoodCount > b.numRemainingFoodCount ? -1 : 1
      );
    }
    var coffeeList = [];
    if (this.state.coffees.length != 0) {
      coffeeList = this.state.coffees?.sort((a, b) =>
        a.numRemainingCoffeeCount > b.numRemainingCoffeeCount ? -1 : 1
      );
    }
    var orderList = [];
    var hasOrder = undefined;
    const shortSupply = 7;
    const underInvestigation = 2;
    var allOrderList = this.props.reducer.coffeeShopAndRestaurantList;
    orderList = allOrderList.filter((o) => {
      if (
        (this.state.orderTypeFilter == "ALL" ||
          this.state.orderTypeFilter == o.data.numPublicServiceType) &&
        (this.state.orderStatusFilter == "ALL" ||
          o.data.numOrderStatus == this.state.orderStatusFilter ||
          (this.state.orderStatusFilter == underInvestigation &&
            o.data.numOrderStatus == shortSupply)) &&
        (!this.state.orderDescriptionFilter ||
          o.data.strOrderDesc.indexOf(this.state.orderDescriptionFilter) >= 0)
      )
        return o;
    });
    if (this.props.reducer.coffeeShopAndRestaurantList.length == 0) {
      hasOrder = "No";
    }
    if (this.props.reducer.coffeeShopAndRestaurantList.length != 0) {
      hasOrder = "Yes";
    }
    orderList.sort((a, b) =>
      a.data.dtRegPDate < b.data.dtRegPDate
        ? 1
        : a.data.dtRegTime < b.data.dtRegTime
        ? 1
        : -1
    );
    // orderStatuses
    if (allOrderList && allOrderList.length > 0) {
      for (var i in allOrderList) {
        var status = allOrderList[i].data.numOrderStatus;
        if (this.orderStatuses.indexOf(status) < 0 && status != shortSupply) {
          this.orderStatuses.push(status);
        }
      }
    }

    // orderTypes
    switch (this.state.orderSortFilter) {
      case this._sortModes.sortByTime:
        orderList.sort((a, b) =>
          a.data.dtRegPDat > b.data.dtRegPDat
            ? 1
            : a.data.dtRegPDat == b.data.dtRegPDat &&
              a.data.dtRegTime > b.data.dtRegTime
            ? 1
            : -1
        );
        break;
      case this._sortModes.sortByType:
        orderList.sort((a, b) =>
          a.data.numPublicServiceType > b.data.numPublicServiceType ? 1 : -1
        );
        break;
    }
    if (orderList && orderList.length > 0) {
      for (var i in orderList) {
        var typ = orderList[i].data.numPublicServiceType;
        if (this.orderTypes.indexOf(typ) < 0) {
          this.orderTypes.push(typ);
        }
      }
    }

    var eatList = [];
    if (this.state.isRestaurantActive) {
      eatList.push({
        label: translate("api.orderTypes.Restaurant"),
        value: "Restaurant",
      });
    }
    if (this.state.isCoffeeShopActive) {
      eatList.push({
        label: translate("api.orderTypes.CoffeeShop"),
        value: "CoffeeShop",
      });
    }

    const startDate = this.state.pDateDesired
      ? this.state.pDateDesired.toString()
      : "";

    // CreditUnitPayment
    var paymentType_Options = [];
    const unitBalance = 1;
    const userBalance = 2;
    const cashPayment = 3;
    const onlinePayment = 4;
    if (!paymentType_Options.length) {
      // paymentType_Options.push({
      //   value: cashPayment,
      //   label: `${translate("api.cashPayment")}`,
      // });
      paymentType_Options.push({
        value: onlinePayment,
        label: `${translate("api.onlinePayment")}`,
      });
      if (this.state.unitBalance >= this.state.orderPrice) {
        paymentType_Options.push({
          value: unitBalance,
          label: `${translate(
            "api.creditUnitPayment"
          )} (${englishToPersianNumber(
            this.state.unitBalance,
            ","
          )} ${translate("api.priceUnit")} )`,
        });
      }
      if (this.state.userBalance >= this.state.orderPrice) {
        paymentType_Options.push({
          value: userBalance,
          label: `${translate(
            "api.creditUserPayment"
          )} (${englishToPersianNumber(
            this.state.userBalance,
            ","
          )} ${translate("api.priceUnit")} )`,
        });
      }
      if (Platform.OS == "web") {
        paymentType_Options.unshift({
          label: translate("api.paymentType"),
          value: "paymentType",
        });
      }
    }
    return (
      <KeyboardAvoidingView behavior="padding" style={{ flex: 1 }}>
        {!this.state.newOrder && this.state.isUserValid == "Yes" && (
          <View style={{ flex: 1 }}>
            {/* TouchableFilters */}
            <FilterItem
              listItem={this.orderTypes.map((s) => {
                return { value: s, text: translate(`api.orderTypes.${s}`) };
              })}
              selectedItem={this.state.orderTypeFilter || this.orderTypes[0]}
              onSelect={(item) => {
                this.setState({
                  orderTypeFilter: item,
                });
              }}
            />
            <FilterItem
              listItem={this.orderStatuses.map((s) => {
                return { value: s, text: translate(`api.orderStatuses.${s}`) };
              })}
              selectedItem={
                this.state.orderStatusFilter || this.orderStatuses[0]
              }
              onSelect={(item) => {
                this.setState({ orderStatusFilter: item });
              }}
            />
            {/* Filters */}
            <View
              style={{
                // paddingStart: 10,
                padding: 5,
                paddingTop: 5,
                backgroundColor: Theme.COLORS.BORDER_COLOR,
                borderBottomWidth: 1,
                borderColor: Theme.COLORS.BORDER,
              }}
            >
              <InputSearch
                placeholder={translate("app.searchInOrderDetails")}
                value={this.state.orderDescriptionFilter}
                onChangeText={(txt) => {
                  this.setState({ orderDescriptionFilter: txt });
                }}
              />
              <View style={{ flex: 1, marginTop: 8 }}>
                <Select
                  data={this._sortModes.getArray()}
                  value={
                    Platform.OS == "web"
                      ? this.state.orderSortFilter
                      : translate("app.orderSortBy") ||
                        this.state.orderSortFilter
                  }
                  onChangeText={(value, index, data) => {
                    this.setState({ orderSortFilter: value });
                  }}
                />
              </View>
            </View>

            {hasOrder == "Yes" && orderList.length != 0 && (
              <ScrollView
                style={{
                  flex: 1,
                  marginBottom: 85,
                }}
              >
                {orderList.map((o, i) => {
                  return (
                    <OrderListItem
                      onPress={() => {
                        this.setState({ showModal: 2, orderSelected: o });
                      }}
                      key={i}
                      orderData={o.data}
                      strService={
                        o.strRestaurantService || o.strCoffeeShopService
                      }
                      toast={this.showToast}
                    />
                  );
                })}
              </ScrollView>
            )}
            {hasOrder == "No" && orderList.length == 0 && (
              <View
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  flex: 1,
                }}
              >
                {!this.state.reservationUser?.boolUserStatus && (
                  <Text
                    style={{
                      fontWeight: "bold",
                      fontSize: 18,
                      color: "#666666",
                    }}
                  >
                    {translate("api.disabledReservationUser")}
                  </Text>
                )}
                {this.state.reservationUser.boolUserStatus && (
                  <Text
                    style={{
                      fontWeight: "bold",
                      fontSize: 18,
                      color: "#666666",
                    }}
                  >
                    {translate("api.noOrderRequest")}
                  </Text>
                )}
              </View>
            )}
            {this.state.reservationUser?.boolUserStatus &&
              (this.state.isRestaurantActive == true ||
                this.state.isCoffeeShopActive == true) && (
                <TouchableHighlight
                  style={style.btnAdd}
                  onPress={
                    (this.onAddButtonPress,
                    () =>
                      this.setState({
                        newOrder: true,
                        orderedItems: [],
                        orderPrice: 0,
                      }))
                  }
                >
                  <FontAwesomeIcon icon={faPlus} size={30} color="#FFF" />
                </TouchableHighlight>
              )}
            {this.state.isRestaurantActive == false &&
              this.state.isCoffeeShopActive == false && (
                <View
                  style={{
                    height: 60,
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: -70,
                    marginBottom: 10,
                  }}
                >
                  <Text style={{ fontWeight: "bold", fontSize: 18 }}>
                    {translate("api.inactiveService")}
                  </Text>
                </View>
              )}

            {/* Details */}
            <ModalBase
              avoidKeyboard={true}
              isOpen={this.state.showModal === 2}
              onClose={() => this.hideModal()}
            >
              {this.state.orderSelected != null && (
                <View
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 15,
                  }}
                >
                  <View
                    style={{
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: SCREEN_WIDTH,
                      marginTop: 7,
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        height: 80,
                        borderColor: Theme.COLORS.BORDER,
                        borderBottomWidth: 1,
                        width: "100%",
                      }}
                    >
                      <IconButton
                        style={{
                          backgroundColor: "#ffffff",
                          width: 70,
                          height: 70,
                          borderRadius: 35,
                          borderWidth: 1,
                          borderColor: "#ccf",
                          marginStart: 22,
                          marginEnd: 22,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        icon={{
                          code: getIconPicture(
                            "facilityIcons",
                            this.state.orderSelected.data.numPublicServiceType
                          ),
                          style: {
                            fontFamily: FONT_FAMILIES.PRO_REGULAR,
                            fontSize: 30,
                            color: "#006666",
                          },
                        }}
                      />
                      <View
                        style={{
                          flex: 1,
                          // alignItems: "flex-start",
                          // alignContent: "flex-end",
                          marginTop: 20,
                          flexDirection: "column",
                        }}
                      >
                        <View
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                          }}
                        >
                          {this.state.orderSelected != null && (
                            <Text
                              style={{
                                alignItems: "flex-end",
                                paddingTop: 8,
                              }}
                            >
                              {translate("api.orderId")} :
                              <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                                {" "}
                                {englishToPersianNumber(
                                  this.state.orderSelected.data.numOrderID
                                )}
                              </Text>
                            </Text>
                          )}
                          {this.state.orderSelected != null && (
                            <Text style={{ paddingTop: 10 }}>
                              {
                                this.state.orderSelected.data.strUnitName.split(
                                  " "
                                )[0]
                              }{" "}
                              <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                                {
                                  this.state.orderSelected.data.strUnitName.split(
                                    " "
                                  )[1]
                                }
                              </Text>
                            </Text>
                          )}
                        </View>
                      </View>
                      {this.state.orderSelected != null && (
                        <IconButton
                          style={{
                            marginBottom: 20,
                            marginEnd: 20,
                            marginStart: 20,
                            backgroundColor: "#ffffff",
                            width: 70,
                            height: 70,
                            borderRadius: 35,
                            borderWidth: 1,
                            borderColor: "#ccf",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          icon={{
                            code: getIconPicture(
                              "statusOrder",
                              this.state.orderSelected.data.numOrderStatus
                            ),
                            style: {
                              fontFamily: FONT_FAMILIES.PRO_REGULAR,
                              fontSize: 30,
                              color: "#999",
                            },
                          }}
                        />
                      )}
                    </View>
                    <View
                      style={{
                        flexDirection: "column",
                        minHeight: 120,
                        // alignItems: "center",
                        alignContent: "center",
                        width: SCREEN_WIDTH * 0.8,
                        paddingBottom: 5,
                        flex: 1,
                      }}
                    >
                      {this.state.orderSelected != null && (
                        <Text style={{ fontWeight: "bold", marginBottom: 2 }}>
                          {translate("api.orderStatus")}:
                          {this.state.orderSelected.data.strOrderStatus}
                        </Text>
                      )}
                      <View
                        style={{
                          flexDirection: "row",
                          paddingStart: 7,
                          paddingTop: 5,
                          height: 60,
                        }}
                      >
                        <View
                          style={{
                            alignItems: "flex-end",
                            flexDirection: "column",
                          }}
                        >
                          {this.state.orderSelected != null && (
                            <Text>
                              {translate("api.orderSelectedDate")} :
                              <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                                {" "}
                                {englishToPersianNumber(
                                  this.state.orderSelected.data.dtRegPDate
                                )}
                              </Text>
                            </Text>
                          )}
                          {this.state.orderSelected != null && (
                            <Text>
                              {translate("api.dateReserve")}:
                              {this.state.orderSelected.data
                                .dtRibbonUserDesiredPDate != null && (
                                <Text
                                  style={{ fontFamily: "IRANSansWebFaNum" }}
                                >
                                  {" "}
                                  {englishToPersianNumber(
                                    this.state.orderSelected.data
                                      .dtRibbonUserDesiredPDate
                                  )}
                                </Text>
                              )}
                              {this.state.orderSelected.data
                                .dtRibbonUserDesiredPDate == null && (
                                <Text
                                  style={{ fontFamily: "IRANSansWebFaNum" }}
                                >
                                  {" "}
                                  {englishToPersianNumber(
                                    this.state.orderSelected.data.dtRegPDate
                                  )}
                                </Text>
                              )}
                            </Text>
                          )}
                        </View>
                        <View
                          style={{
                            alignItems: "flex-start",
                            flexDirection: "column",
                          }}
                        >
                          {this.state.orderSelected != null && (
                            <Text style={{ marginStart: 55 }}>
                              {translate("api.orderSelectedTime")} :
                              <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                                {" "}
                                {englishToPersianNumber(
                                  this.state.orderSelected.data.dtRegTime
                                )}
                              </Text>
                            </Text>
                          )}

                          {this.state.orderSelected != null && (
                            <Text style={{ marginStart: 69 }}>
                              {translate("api.timeReserve")}:
                              <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                                {" "}
                                {englishToPersianNumber(
                                  this.state.orderSelected.data
                                    .dtRibbonUserDesiredBeginTime
                                )}
                                {"-"}
                                {englishToPersianNumber(
                                  this.state.orderSelected.data
                                    .dtRibbonUserDesiredEndTime
                                )}
                              </Text>
                            </Text>
                          )}
                        </View>
                      </View>

                      <View
                        style={{
                          alignItems: "flex-end",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          // marginStart:-20,
                          marginEnd: -20,
                        }}
                      >
                        <Text
                          style={{
                            alignItems: "flex-end",
                            fontWeight: "bold",
                          }}
                        >
                          {translate("api.orderPrice")} :
                          <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                            {" "}
                            {englishToPersianNumber(
                              this.state.orderSelected.data.numOrderPrice,
                              ","
                            )}{" "}
                          </Text>
                          <Text>{translate("api.priceUnit")}</Text>
                        </Text>
                        {this.state.orderSelected != null &&
                          this.state.orderSelected?.data.payment
                            .numPaymentStatus == 0 &&
                          this.state.orderSelected?.data.payment
                            .numPaymentType == 4 &&
                          (this.state.orderSelected.data.numOrderStatus == 1 ||
                            this.state.orderSelected.data.numOrderStatus == 2 ||
                            this.state.orderSelected.data.numOrderStatus ==
                              7) && (
                            <TouchableHighlight
                              underlayColor={Theme.COLORS.BORDER}
                              onPress={() => {
                                this.getPaymentOnlineUrl();
                              }}
                              style={{
                                borderColor: Theme.COLORS.BORDER,
                                borderWidth: 1,
                                backgroundColor: "#fff",
                                borderRadius: 3,
                                height: 33,
                                // marginBottom: 8,
                                padding: 9,
                                marginEnd: 8,
                                width: 120,
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Text style={{ textAlign: "center" }}>
                                {translate("api.onlinePayment")}
                              </Text>
                            </TouchableHighlight>
                          )}
                      </View>
                      <View
                        style={{
                          alignItems: "flex-end",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginTop: 3,
                        }}
                      >
                        {this.state.orderSelected != null && (
                          <Text>
                            {translate("api.paymentTypeString")}
                            {": "}
                            {translate(
                              "api.paymentTypeCode".concat(
                                ".",
                                this.state.orderSelected.data.payment
                                  .numPaymentType
                              )
                            )}
                          </Text>
                        )}
                        {this.state.orderSelected != null && (
                          <Text>
                            {translate("api.paymentStatusString")}
                            {": "}
                            {translate(
                              "api.paymentStatusCode".concat(
                                ".",
                                this.state.orderSelected.data.payment
                                  .numPaymentStatus
                              )
                            )}
                          </Text>
                        )}
                      </View>
                      {this.state.orderSelected != null && (
                        <View
                          style={{
                            height: 20,
                            paddingBottom: 10,
                            flex: 1,
                            marginTop: 5,
                            marginBottom: 5,
                          }}
                        >
                          <InputBase
                            value={this.state.orderSelected.data.strOrderDesc}
                            label={translate("api.orderDescription")}
                            isDisabled={true}
                          />
                        </View>
                      )}
                    </View>
                    <View
                      style={{
                        flex: 1,
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "column",
                          paddingTop: 5,
                        }}
                      >
                        <View style={{ height: 160 }}>
                          <View
                            style={{
                              flexDirection: "column",
                              alignContent: "space-around",
                              alignItems: "center",
                              borderColor: Theme.COLORS.BORDER,
                              borderBottomWidth: 1,
                              width: SCREEN_WIDTH * 0.8,
                              marginBottom: 5,
                              marginTop: 20,
                              // height: 60,
                            }}
                          >
                            {this.state.orderSelected != null && (
                              <ScrollView
                                persistentScrollbar={true}
                                contentContainerStyle={{
                                  marginHorizontal: 1,
                                  borderRadius: 4,
                                  borderColor: Theme.COLORS.BORDER,
                                }}
                              >
                                {this.state.orderSelected.data.lstItem.map(
                                  (o, i) => (
                                    <View
                                      key={i}
                                      style={{
                                        flexDirection: "row",
                                        alignItems: "flex-start",
                                        justifyContent: "flex-end",
                                        paddingStart: 5,
                                      }}
                                    >
                                      <Text>
                                        {o.strFoodName || o.strCoffeeName}{" "}
                                      </Text>
                                      <Text
                                        style={{
                                          fontFamily: "IRANSansWebFaNum",
                                        }}
                                      >
                                        {englishToPersianNumber(
                                          o.numOrderItemPrice,
                                          ","
                                        )}{" "}
                                        {")"}
                                      </Text>
                                      <Text>
                                        {translate("api.priceUnit")}
                                        {")"}
                                      </Text>
                                    </View>
                                  )
                                )}
                              </ScrollView>
                            )}
                          </View>
                          <View style={{ alignItems: "center" }}>
                            {this.state.orderSelected != null && (
                              <Text>
                                {" "}
                                {translate("api.orderPrice")} :
                                <Text
                                  style={{ fontFamily: "IRANSansWebFaNum" }}
                                >
                                  {" "}
                                  {englishToPersianNumber(
                                    this.state.orderSelected.data.numOrderPrice,
                                    ","
                                  )}{" "}
                                </Text>
                                <Text>{translate("api.priceUnit")}</Text>
                              </Text>
                            )}
                          </View>
                        </View>
                      </View>
                    </View>
                    <View
                      style={{
                        alignItems: "center",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <View
                        style={{
                          // paddingEnd: 10,
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        {this.state.orderSelected?.data.numOrderStatus == 1 && (
                          <TouchableHighlight
                            underlayColor={Theme.COLORS.BORDER}
                            onPress={() => {
                              this.setState({ isShowingCancelAlert: true });
                            }}
                            style={{
                              borderColor: Theme.COLORS.BORDER,
                              borderWidth: 1,
                              backgroundColor: "#fff",
                              borderRadius: 3,
                              height: 37,
                              marginBottom: 15,
                              padding: 9,
                              marginEnd: 30,
                              width: 150,
                            }}
                          >
                            <Text style={{ textAlign: "center" }}>
                              {translate("app.alertTitleCancel")}
                            </Text>
                          </TouchableHighlight>
                        )}
                        <TouchableHighlight
                          underlayColor={Theme.COLORS.BORDER}
                          onPress={() => this.hideModal()}
                          style={{
                            borderColor: Theme.COLORS.BORDER,
                            borderWidth: 1,
                            backgroundColor: "#fff",
                            borderRadius: 3,
                            height: 37,
                            marginBottom: 15,
                            padding: 9,
                            width: 150,
                          }}
                        >
                          <Text style={{ textAlign: "center" }}>
                            {translate("api.closeOrderSelected")}
                          </Text>
                        </TouchableHighlight>
                        {this.state.isShowingCancelAlert && (
                          <AlertDialogBase
                            isOpen={true}
                            title={translate("app.alertTitleCancel")}
                            confirmText={translate("app.confirm")}
                            colorConfirm="primary"
                            confirmHandler={() => {
                              this.cancelOrder();
                              this.hideCancelConfirm();
                            }}
                            onClose={() => {
                              this.hideCancelConfirm();
                            }}
                          >
                            <Text>{translate("api.isConfirmCancel")}</Text>
                          </AlertDialogBase>
                        )}
                      </View>
                    </View>
                  </View>
                </View>
              )}
            </ModalBase>
          </View>
        )}

        {this.state.newOrder && this.state.isUserValid == "Yes" && (
          <View style={{ flex: 1 }}>
            <View style={{ flexDirection: "column" }}>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 7,
                }}
              >
                <IconButton
                  style={{
                    backgroundColor: "#ffffff",
                    width: 70,
                    height: 70,
                    borderRadius: 35,
                    borderWidth: 1,
                    borderColor: "#ccf",
                    marginStart: 22,
                    marginEnd: 22,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  icon={{
                    code: getIconPicture(
                      "facilityIcons",
                      this.state.newOrderType
                    ),
                    style: {
                      fontFamily: FONT_FAMILIES.PRO_REGULAR,
                      fontSize: 30,
                      color: getIconPicture(
                        "facilityIcons",
                        this.state.newOrderType
                      )
                        ? "#006666"
                        : "#ccc",
                    },
                  }}
                />
              </View>
              <View
                style={{
                  flexDirection: "row",
                  borderBottomColor: Theme.COLORS.BORDER,
                  borderBottomWidth: 1,
                }}
              >
                <View style={{ flex: 2, padding: 10 }}>
                  <Select
                    data={eatList}
                    value={this.state.newOrderType || eatList[0].value}
                    onChangeText={(value, index, data) => {
                      this.setState({
                        isNewOrder: true,
                        selectedTypeCategory: 0,
                        newOrderType: value,
                        orderPrice: 0,
                        allNumItems: 0,
                        orderItems: [],
                      });
                    }}
                  />
                </View>
                <View
                  style={{
                    flex: 2,
                    padding: 10,
                    paddingTop: 0,
                    marginTop: -10,
                  }}
                >
                  <TouchableHighlight
                    onPress={() => {
                      this.setState({ twoModals: true });
                    }}
                    underlayColor={Theme.COLORS.BORDER}
                    style={{
                      borderColor: Theme.COLORS.BORDER,
                      borderWidth: 1,
                      borderRadius: 4,
                      backgroundColor: "#FFFFFF",
                      shadowColor: Theme.COLORS.BLACK,
                      shadowOffset: { width: 0, height: 1 },
                      shadowRadius: 2,
                      shadowOpacity: 0.05,
                      elevation: 2,
                      paddingStart: 5,
                      paddingEnd: 10,
                      marginTop: 20,
                      height: 45,
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        padding: 10,
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faCalendar}
                        color="gray"
                        size={20}
                      />
                      {this.state.pDateDesired != null && (
                        <Text
                          style={{
                            paddingEnd: 6,
                            fontFamily: "IRANSansWebFaNum",
                            fontSize: 12,
                          }}
                        >
                          {moment(startDate).format("jYYYY/jM/jD")}
                        </Text>
                      )}
                      {this.state.pDateDesired == null && (
                        <Text
                          style={{
                            paddingEnd: 6,
                            fontFamily: "IRANSansWebFaNum",
                            fontSize: 12,
                          }}
                        >
                          {Platform.OS == "web"
                            ? new Date().toLocaleDateString("fa-IR")
                            : moment(
                                new Date().toLocaleDateString("fa-IR")
                              ).format("jYYYY/jM/jD")}
                        </Text>
                      )}
                    </View>
                  </TouchableHighlight>
                  {/* calender */}
                  {this.state.twoModals && (
                    <ModalBase
                      avoidKeyboard={true}
                      isOpen={this.state.twoModals}
                      onClose={() => this.hideTwoModals()}
                    >
                      <View
                        style={{
                          justifyContent: "center",
                          backgroundColor: "#fff",
                          alignItems: "center",
                          borderRadius: 5,
                          marginTop: 50,
                          padding: 10,
                        }}
                      >
                        <PersianCalendarPicker
                          textStyle={{ fontFamily: "IRANSansWebFaNum" }}
                          minDate={new Date().toLocaleDateString("fa-IR")}
                          onDateChange={this.onDateChange}
                          selectedDayColor="blue"
                          scaleFactor={SCREEN_WIDTH * 1.2}
                        ></PersianCalendarPicker>
                      </View>
                    </ModalBase>
                  )}
                </View>
                <View style={{ flex: 2, padding: 10 }}>
                  <Select
                    data={this.state.areaList}
                    value={
                      Platform.OS == "web"
                        ? this.state.newOrderUnitId
                        : translate("api.orderUnit") ||
                          this.state.newOrderUnitId
                    }
                    onChangeText={(value) => {
                      this.setState({ isNewOrder: true });
                      if (Number.isInteger(value) || Number(value) > 0) {
                        this.setState({
                          newOrderUnitId: Number(value),
                          isAccessToUnitCredit: this.state.areaList.map(
                            (i) => i.value == value
                          )?.boolUseUnitCredit,
                        });
                      }
                    }}
                  />
                </View>
              </View>
            </View>
            <View style={{ flexDirection: "column", flex: 1 }}>
              {this.state.newOrderType == "Restaurant" && (
                <FilterItem
                  listItem={this.state.restaurantTypeList}
                  selectedItem={
                    this.state.selectedTypeCategory ||
                    this.state.restaurantTypeList[0].value
                  }
                  onSelect={(item) => {
                    this.setState({ selectedTypeCategory: item });
                  }}
                ></FilterItem>
              )}
              {this.state.newOrderType == "CoffeeShop" && (
                <FilterItem
                  listItem={this.state.coffeeShopTypeList}
                  selectedItem={
                    this.state.selectedTypeCategory ||
                    this.state.coffeeShopTypeList[0].value
                  }
                  onSelect={(item) => {
                    this.setState({ selectedTypeCategory: item });
                  }}
                ></FilterItem>
              )}
              <View style={{ flex: 1 }}>
                {this.state.newOrderType == "Restaurant" &&
                  this.state.isRestaurantActive == true && (
                    <ScrollView
                      persistentScrollbar={true}
                      contentContainerStyle={{
                        marginHorizontal: 1,
                        borderRadius: 4,
                        borderColor: Theme.COLORS.BORDER,
                        marginTop: 3,
                      }}
                    >
                      {foodList.map(
                        (o, i) =>
                          (this.state.selectedTypeCategory == 0 ||
                            this.state.selectedTypeCategory ==
                              o.numFoodType) && (
                            <TouchableHighlight key={i}>
                              <View
                                style={{
                                  flexDirection: "row",
                                  marginBottom: 2.5,
                                  marginTop: 2.5,
                                  borderColor: Theme.COLORS.BORDER,
                                  borderWidth: 1,
                                  backgroundColor: "#ffffff",
                                }}
                              >
                                <Image
                                  style={{
                                    marginStart: 4,
                                    marginEnd: 20,
                                    height: 75,
                                    width: 75,
                                  }}
                                  source={{
                                    uri: (this.state.imageUrl =
                                      this.state.imageServerUrl.concat(
                                        "",
                                        o.strImageUrl
                                      )),
                                  }}
                                />
                                <View
                                  style={{
                                    flexDirection: "column",
                                    justifyContent: "flex-start",
                                    marginStart: SCREEN_WIDTH * 0.01,
                                    justifyContent: "center",
                                    width: "40%",
                                  }}
                                >
                                  <Text
                                    style={{
                                      fontSize: 16,
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    }}
                                  >
                                    {o.strFoodName}{" "}
                                  </Text>
                                  <Text style={{ fontSize: 14 }}>
                                    {translate("api.price")}:{" "}
                                    <Text
                                      style={{
                                        fontSize: 14,
                                        fontFamily: "IRANSansWebFaNum",
                                      }}
                                    >
                                      {englishToPersianNumber(o.numPrice, ",")}
                                    </Text>
                                    {translate("api.priceUnit")}
                                  </Text>
                                  <Text>
                                    {translate("api.stock")}:{" "}
                                    <Text
                                      style={{ fontFamily: "IRANSansWebFaNum" }}
                                    >
                                      {o.numRemainingFoodCount}
                                    </Text>
                                  </Text>
                                </View>
                                <View
                                  style={{
                                    alignItems: "flex-end",
                                    justifyContent: "center",
                                    paddingEnd: 5,
                                    flex: 1,
                                  }}
                                >
                                  {this.state.orderedItems.indexOf(o) == -1 && (
                                    <IconButton
                                      key={o.numFoodCode}
                                      style={{
                                        alignItems: "center",
                                        marginEnd: 35,
                                        marginStart: 10,
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                      icon={{
                                        code: "\uf055",
                                        style: {
                                          fontFamily: "FontAwesomeProLight",
                                          fontSize: 30,
                                          color: "#EA3788",
                                        },
                                      }}
                                      onPress={() => {
                                        this.countOrderedItem(
                                          this.state.minItemNum,
                                          o
                                        );
                                      }}
                                    />
                                  )}
                                  {this.state.orderedItems.length >= 1 &&
                                    this.state.orderedItems.includes(o) && (
                                      <InputSpinner
                                        key={o.numFoodCode}
                                        value={o.itemNum}
                                        onChange={(value) =>
                                          this.countOrderedItem(value, o)
                                        }
                                        min={this.state.minItemNum - 1}
                                        max={o.numRemainingFoodCount}
                                        step={1}
                                        skin="round"
                                        buttonFontSize={14}
                                        fontSize={14}
                                        style={{ height: 15, width: 100 }}
                                        height={30}
                                        width={100}
                                      />
                                    )}
                                </View>
                              </View>
                            </TouchableHighlight>
                          )
                      )}
                    </ScrollView>
                  )}
                {this.state.newOrderType == "CoffeeShop" &&
                  this.state.isCoffeeShopActive == true && (
                    <ScrollView
                      persistentScrollbar={true}
                      contentContainerStyle={{
                        marginHorizontal: 1,
                        borderRadius: 4,
                        borderColor: Theme.COLORS.BORDER,
                        marginTop: 3,
                      }}
                    >
                      {coffeeList.map(
                        (o, i) =>
                          (this.state.selectedTypeCategory == 0 ||
                            this.state.selectedTypeCategory ==
                              o.numCoffeeType) && (
                            <TouchableHighlight key={i}>
                              <View
                                style={{
                                  flexDirection: "row",
                                  marginBottom: 2.5,
                                  marginTop: 2.5,
                                  borderColor: Theme.COLORS.BORDER,
                                  borderWidth: 1,
                                  backgroundColor: "#ffffff",
                                }}
                              >
                                <Image
                                  style={{
                                    marginStart: 4,
                                    marginEnd: 20,
                                    height: 75,
                                    width: 75,
                                  }}
                                  source={{
                                    uri: (this.state.imageUrl =
                                      this.state.imageServerUrl.concat(
                                        "",
                                        o.strImageUrl
                                      )),
                                  }}
                                />
                                <View
                                  style={{
                                    flexDirection: "column",
                                    justifyContent: "flex-start",
                                    marginStart: SCREEN_WIDTH * 0.01,
                                    justifyContent: "center",
                                    width: "40%",
                                  }}
                                >
                                  <Text
                                    style={{
                                      fontSize: 16,
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    }}
                                  >
                                    {o.strCoffeeName}{" "}
                                  </Text>
                                  <Text style={{ fontSize: 14 }}>
                                    {translate("api.price")}:{" "}
                                    <Text
                                      style={{
                                        fontSize: 14,
                                        fontFamily: "IRANSansWebFaNum",
                                      }}
                                    >
                                      {englishToPersianNumber(o.numPrice, ",")}
                                    </Text>
                                    {translate("api.priceUnit")}
                                  </Text>
                                  <Text>
                                    {translate("api.stock")}:{" "}
                                    <Text
                                      style={{ fontFamily: "IRANSansWebFaNum" }}
                                    >
                                      {o.numRemainingCoffeeCount}
                                    </Text>
                                  </Text>
                                </View>
                                <View
                                  style={{
                                    alignItems: "flex-end",
                                    justifyContent: "center",
                                    paddingEnd: 5,
                                    flex: 1,
                                  }}
                                >
                                  {this.state.orderedItems.indexOf(o) == -1 && (
                                    <IconButton
                                      key={o.numCoffeeCode}
                                      style={{
                                        alignItems: "center",
                                        marginEnd: 35,
                                        marginStart: 10,
                                      }}
                                      icon={{
                                        code: "\uf055",
                                        style: {
                                          fontFamily: "FontAwesomeProLight",
                                          fontSize: 30,
                                          color: "#EA3788",
                                        },
                                      }}
                                      onPress={() => {
                                        this.countOrderedItem(
                                          this.state.minItemNum,
                                          o
                                        );
                                      }}
                                    />
                                  )}
                                  {this.state.orderedItems.length >= 1 &&
                                    this.state.orderedItems.includes(o) && (
                                      <InputSpinner
                                        key={o.numCoffeeCode}
                                        value={o.itemNum}
                                        onChange={(value) =>
                                          this.countOrderedItem(value, o)
                                        }
                                        minValue={this.state.minItemNum - 1}
                                        maxValue={o.numRemainingCoffeeCount}
                                        totalWidth={100}
                                        totalHeight={30}
                                        iconSize={30}
                                        step={1}
                                        skin="round"
                                        buttonFontSize={14}
                                        fontSize={14}
                                        style={{ height: 15, width: 100 }}
                                        height={30}
                                        width={100}
                                      />
                                    )}
                                </View>
                              </View>
                            </TouchableHighlight>
                          )
                      )}
                    </ScrollView>
                  )}
              </View>
            </View>
            <View
              style={{ alignItems: "center", marginBottom: 15, marginTop: 15 }}
            >
              <TouchableHighlight
                underlayColor={Theme.COLORS.BORDER}
                style={
                  Platform.OS == "web"
                    ? style.webTouchableYourOrder
                    : style.appTouchableYourOrder
                }
                onPress={() => {
                  this.state.orderedItems.length != 0 &&
                    this.state.newOrderUnitId != null &&
                    this.setState({ showModal: 1 }, () => {
                      this.getBalanceAmount();
                    });
                  this.state.orderedItems.length == 0 &&
                    this.showToast(translate("api.noOrdered"));
                  this.state.newOrderUnitId == null &&
                    this.showToast(translate("api.enterUnit"));
                }}
              >
                <View style={{ flexDirection: "row", marginTop: 5 }}>
                  <View style={{ marginTop: 5 }}>
                    <Text>{translate("api.yourOrders")}</Text>
                  </View>
                  <IconButton
                    style={{
                      marginEnd: 3,
                      marginStart: 10,
                      marginTop: 2,
                    }}
                    icon={{
                      code: "\uf07a",
                      style: {
                        fontFamily: "FontAwesomeProLight",
                        fontSize: 26,
                      },
                    }}
                    onPress={() => {
                      this.state.orderedItems.length != 0 &&
                        this.state.newOrderUnitId != null &&
                        this.setState({ showModal: 1 }, () => {
                          this.getBalanceAmount();
                        });
                      this.state.orderedItems.length == 0 &&
                        this.showToast(translate("api.noOrdered"));
                    }}
                  />
                  {this.state.orderedItems.length != 0 &&
                    this.state.allNumItems != 0 && (
                      <View
                        style={{
                          backgroundColor: "#EA3788",
                          borderRadius: 25,
                          height: 20,
                          width: 20,
                          borderColor: "#cccccc32",
                          borderWidth: 1,
                          marginBottom: 40,
                          marginTop: -5,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Text
                          style={{
                            color: "white",
                            fontFamily: "IRANSansWebFaNum",
                            fontSize: 10,
                            fontWeight: "bold",
                          }}
                        >
                          {this.state.allNumItems}
                        </Text>
                      </View>
                    )}
                </View>
              </TouchableHighlight>
            </View>
            {/* new order */}
            <ModalBase
              avoidKeyboard={true}
              isOpen={
                this.state.showModal == 1 && this.state.orderedItems.length
              }
              onClose={() => this.hideModal()}
            >
              <View
                style={
                  Platform.OS == "web"
                    ? style.webModalNewOrder
                    : style.appModalNewOrder
                }
              >
                <View
                  style={{
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 7,
                  }}
                >
                  <IconButton
                    style={{
                      backgroundColor: "#ffffff",
                      width: 70,
                      height: 70,
                      borderRadius: 35,
                      borderWidth: 1,
                      borderColor: "#ccf",
                      marginStart: 22,
                      marginEnd: 22,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    icon={{
                      code: getIconPicture(
                        "facilityIcons",
                        this.state.newOrderType
                      ),
                      style: {
                        fontFamily: FONT_FAMILIES.PRO_REGULAR,
                        fontSize: 30,
                        color: getIconPicture(
                          "facilityIcons",
                          this.state.newOrderType
                        )
                          ? "#006666"
                          : "#ccc",
                      },
                    }}
                  />
                  <View
                    style={{
                      borderColor: Theme.COLORS.BORDER,
                      borderRadius: 1,
                      borderWidth: 1,
                      flexDirection: "column",
                      alignContent: "center",
                      height: SCREEN_WIDTH,
                      marginTop: 5,
                      flex: 1,
                      padding: 10,
                      justifyContent: "space-around",
                    }}
                  >
                    <View style={{ alignItems: "flex-end" }}>
                      <IconButton
                        icon={{
                          code: "\uf2ed",
                          style: {
                            fontFamily: "FontAwesomeProLight",
                            fontSize: 25,
                            color: "#EA3788",
                            alignItems: "center",
                            justifyContent: "center",
                          },
                        }}
                        onPress={() => {
                          this.clearCart();
                        }}
                      />
                    </View>
                    <View
                      style={
                        Platform.OS == "web"
                          ? style.webScrollNewOrderItem
                          : style.appScrollNewOrderItem
                      }
                    >
                      <ScrollView
                        persistentScrollbar={true}
                        contentContainerStyle={{
                          marginHorizontal: 1,
                          borderRadius: 4,
                          borderColor: Theme.COLORS.BORDER,
                          marginTop: 3,
                        }}
                        style={{
                          flex: 1,
                        }}
                      >
                        {this.state.orderedItems.map((o, i) => (
                          <TouchableHighlight key={i}>
                            <View
                              style={{
                                flexDirection: "row",
                                marginBottom: 2.5,
                                marginTop: 2.5,
                                borderColor: Theme.COLORS.BORDER,
                                borderWidth: 1,
                                backgroundColor: "#ffffff",
                              }}
                            >
                              <Image
                                style={{
                                  marginStart: 4,
                                  marginEnd: 20,
                                  height: 60,
                                  width: 60,
                                }}
                                source={{
                                  uri: (this.state.imageUrl =
                                    this.state.imageServerUrl.concat(
                                      "",
                                      o.strImageUrl
                                    )),
                                }}
                              />
                              <View
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "flex-start",
                                  marginStart: SCREEN_WIDTH * 0.01,
                                  justifyContent: "center",
                                  width: "40%",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 14,
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  }}
                                >
                                  {o.strFoodName || o.strCoffeeName}{" "}
                                </Text>
                                <Text style={{ fontSize: 12 }}>
                                  {translate("api.price")}:{" "}
                                  <Text
                                    style={{
                                      fontSize: 12,
                                      fontFamily: "IRANSansWebFaNum",
                                    }}
                                  >
                                    {englishToPersianNumber(o.numPrice, ",")}
                                  </Text>
                                  {translate("api.priceUnit")}
                                </Text>
                                <Text>
                                  {translate("api.stock")}:{" "}
                                  <Text
                                    style={{
                                      fontFamily: "IRANSansWebFaNum",
                                      marginBottom: 3,
                                    }}
                                  >
                                    {o.numRemainingFoodCount ||
                                      o.numRemainingCoffeeCount}
                                  </Text>
                                </Text>
                              </View>
                              <View
                                style={{
                                  alignItems: "flex-end",
                                  justifyContent: "center",
                                  paddingEnd: 5,
                                  flex: 1,
                                }}
                              >
                                {this.state.orderedItems.length >= 1 && (
                                  <InputSpinner
                                    key={o.numFoodCode || o.numCoffeeCode}
                                    value={o.itemNum}
                                    onChange={(value) =>
                                      this.countOrderedItem(value, o)
                                    }
                                    minValue={this.state.minItemNum - 1}
                                    maxValue={
                                      o.numRemainingFoodCount ||
                                      o.numRemainingCoffeeCount
                                    }
                                    totalWidth={100}
                                    totalHeight={30}
                                    iconSize={30}
                                    step={1}
                                    skin="round"
                                    buttonFontSize={14}
                                    fontSize={14}
                                    style={{ height: 15, width: 100 }}
                                    height={25}
                                    width={90}
                                  />
                                )}
                              </View>
                            </View>
                          </TouchableHighlight>
                        ))}
                      </ScrollView>
                    </View>
                    <View>
                      <InputBase
                        label={translate("api.orderDescription")}
                        value={this.state.orderDesc}
                        onChangeText={(text) => {
                          this.setState({ orderDesc: text });
                        }}
                      />
                    </View>
                    <View style={{ justifyContent: "flex-end" }}>
                      <Text>
                        {translate("api.servicePrice").concat(" : ")}
                        {this.state.orderPrice != 0 && (
                          <Text>
                            <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                              {englishToPersianNumber(
                                this.state.orderPrice,
                                ","
                              )}{" "}
                            </Text>
                            {translate("api.priceUnit")}
                          </Text>
                        )}
                      </Text>
                    </View>
                    <View style={{ marginTop: 8 }}>
                      <Select
                        label={null}
                        data={paymentType_Options}
                        value={
                          Platform.OS == "web"
                            ? this.state.selectedPaymentItem
                            : translate("api.paymentType") ||
                              this.state.selectedPaymentItem
                        }
                        onChangeText={(value, index, data) => {
                          if (Number(value) > 0) {
                            this.setState({
                              selectedPaymentItem: Number(value),
                            });
                          }
                        }}
                      />
                    </View>
                  </View>
                  <View
                    style={{
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexDirection: "row",
                    }}
                  >
                    <TouchableHighlight
                      onPress={() => {
                        this.hideModal();
                      }}
                      underlayColor={Theme.COLORS.BORDER}
                      style={{
                        borderColor: Theme.COLORS.BORDER,
                        borderWidth: 1,
                        backgroundColor: "#fff",
                        borderRadius: 3,
                        height: 37,
                        padding: 9,
                        width: 150,
                        margin: 10,
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Text style={{ textAlign: "center" }}>
                        {translate("api.back")}
                      </Text>
                    </TouchableHighlight>
                    <TouchableHighlight
                      onPress={() => {
                        if (this.state.isOrderRegistering) {
                          this.setState({ isOrderRegistering: false }, () => {
                            this.registerNewOrder();
                          });
                        }
                      }}
                      underlayColor={Theme.COLORS.BORDER}
                      style={{
                        borderColor: Theme.COLORS.BORDER,
                        borderWidth: 1,
                        backgroundColor: "#fff",
                        borderRadius: 3,
                        height: 37,
                        padding: 9,
                        width: 150,
                        margin: 10,
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Text style={{ textAlign: "center" }}>
                        {(this.state.selectedPaymentItem != 4 &&
                          translate("api.registration")) ||
                          (this.state.selectedPaymentItem == 4 &&
                            translate("api.registration&Payment"))}
                      </Text>
                    </TouchableHighlight>
                  </View>
                </View>
              </View>
            </ModalBase>
          </View>
        )}
      </KeyboardAvoidingView>
    );
  }
}

const style = StyleSheet.create({
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 26,
    marginBottom: 16,
    marginTop: 16,
  },
  btnAdd: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: Theme.COLORS.PRIMARY,
    position: "absolute",
    bottom: 15,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  appTouchableYourOrder: {
    borderColor: Theme.COLORS.BORDER,
    borderWidth: 1,
    backgroundColor: "#fff",
    borderRadius: 3,
    height: 50,
    padding: 9,
    width: 150,
  },
  webTouchableYourOrder: {
    borderColor: Theme.COLORS.BORDER,
    borderWidth: 1,
    backgroundColor: "#fff",
    borderRadius: 3,
    height: 50,
    padding: 9,
    width: 170,
  },
  webScrollNewOrderItem: {
    height: 100,
    marginBottom: 10,
    marginTop: 10,
  },
  appScrollNewOrderItem: {
    flex: 1,
  },
  webModalNewOrder: {
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    minHeight: SCREEN_WIDTH * 0.14,
    minWidth: SCREEN_WIDTH * 0.14,
  },
  appModalNewOrder: {
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    minHeight: SCREEN_WIDTH * 1.14,
    minWidth: SCREEN_WIDTH * 1.14,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.ApiReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    MyOrders: (accessToken) =>
      dispatch(Actions.MyCoffeeShopAndRestaurantOrders(accessToken)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RestaurantAndCoffeeShopScreen);
